import {
  IconButton,
  TextButton,
  Typography,
  Box,
  Modal,
  Divider,
  useMediaQuery,
} from 'bonfire-kindling';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

const SignUpModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const isMobileWidth = useMediaQuery(theme => theme.breakpoints.down('sm'));

  return (
    <Modal open={open} size={isMobileWidth ? 'tiny' : 'medium'}>
      <Box p={4}>
        <Box display="flex" justifyContent="space-between" alignItems="start" mb={2}>
          <Typography variant="h4" component="h2" sx={{ mt: 3 }}>
            {t('preview.sign_up_modal.subscribe_to_premium_vendor')}
          </Typography>
          <IconButton onClick={onClose} iconName="times" borderless />
        </Box>
        <Typography component="p">{t('preview.sign_up_modal.to_view_this_project')}</Typography>
      </Box>
      <Divider />
      <Box display="flex" justifyContent="right" p={4}>
        <TextButton
          component={RouterLink}
          to="/login"
          label={t('preview.sign_up_modal.log_in')}
          variant="outline"
          sx={{ ml: 3 }}
        />
        <TextButton
          component={RouterLink}
          to="/subscribe"
          label={t('preview.sign_up_modal.sign_up')}
          sx={{ ml: 3 }}
        />
      </Box>
    </Modal>
  );
};

export default SignUpModal;
